import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';

class PersonsFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            person,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            isEdit,
            setFormikState,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="id_person" value={values.id_person} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6}>
                        <FormField
                            type="text"
                            disabled
                            autoComplete={false}
                            name="person_name"
                            label={i18n.get('accounts.person')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={person.first_name + ' ' + person.last_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="id_course"
                            label={i18n.get('contracts.course_name')}
                            url="/search-course"
                            onChange={option => {
                                values.id_course = option.value;
                                if ( option.entity ) {
                                    values.course = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.course && [{
                                'value': values.course.id,
                                'label': values.course.name,
                                'entity': values.course,
                            }]}
                            value={values.course && {
                                'value': values.course.id,
                                'label': values.course.name,
                                'entity': values.course,
                            }}
                            error={errors.id_course}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <FormDate
                            type="date"
                            name="day_contract_start"
                            label={i18n.get('contracts.day_contract_start')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract_start}
                            error={errors.day_contract_start}
                            touched={touched.day_contract_start}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <FormDate
                            type="date"
                            name="day_contract_end"
                            label={i18n.get('contracts.day_contract_end')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract_end}
                            error={errors.day_contract_end}
                            touched={touched.day_contract_end}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormField
                            type="number"
                            name="lessons"
                            label={i18n.get('contracts.lessons')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.lessons}
                            error={errors.lessons}
                            touched={touched.lessons}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormField
                            type="text"
                            name="payment"
                            label={i18n.get('contracts.payment')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.payment}
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <FormDate
                            type="date"
                            name="day_contract"
                            label={i18n.get('contracts.day_contract')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_contract}
                            error={errors.day_contract}
                            touched={touched.day_contract}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="qualification_id"
                            label={i18n.get('persons.qualification')}
                            url="/search-qualification"
                            onChange={option => {
                                values.qualification_id = option.value;
                                if ( option.entity ) {
                                    values.qualification = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.qualification && [{
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }]}
                            value={values.qualification && {
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }}
                            error={errors.qualification_id}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/persons/${values.id}`}
                                confirmMessage={i18n.get('persons.confirm_message')}
                                successMessage={i18n.get('persons.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default PersonsFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contracts/ContractFormFields.js